"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorClient = void 0;
const web3 = __importStar(require("@solana/web3.js"));
const anchor = __importStar(require("@coral-xyz/anchor"));
const web3_js_1 = require("@solana/web3.js");
const bn_js_1 = __importDefault(require("bn.js"));
const utils_1 = require("./utils");
const defs_1 = require("./defs");
const bolt_sdk_1 = require("bolt-sdk");
const bs58_1 = require("bs58");
const yggdrasil_bolt_json_1 = __importDefault(require("./target/idl/yggdrasil_bolt.json"));
const creature_json_1 = __importDefault(require("./target/idl/creature.json"));
const world_json_1 = __importDefault(require("./target/idl/world.json"));
const modify_creature_json_1 = __importDefault(require("./target/idl/modify_creature.json"));
const source_perform_action_on_target_using_json_1 = __importDefault(require("./target/idl/source_perform_action_on_target_using.json"));
const defs_2 = require("./defs");
const utils_2 = require("../utils");
var Modification;
(function (Modification) {
    Modification["Initialize"] = "Initialize";
})(Modification || (Modification = {}));
var Action;
(function (Action) {
    Action["Damage"] = "Damage";
})(Action || (Action = {}));
class AnchorClient {
    constructor({ cluster, anchorWallet, wallet, }) {
        this.anchorWallet = anchorWallet;
        this.wallet = wallet;
        if (process.env.ENVIRONMENT === "devnet") {
            this.cluster = "https://api.devnet.solana.com";
        }
        else if (process.env.ENVIRONMENT === "localnet") {
            this.cluster = "http://127.0.0.1:8899";
        }
        else if (process.env.ENVIRONMENT === "mainnet") {
            this.cluster = "https://api.mainnet-beta.solana.com";
        }
        else {
            throw new Error(`Invalid ENVIRONMENT=${process.env.ENVIRONMENT}`);
        }
        this.connection = new web3.Connection(this.cluster, "confirmed");
        console.log(`Connected to cluster: ${this.cluster}`);
        this.provider = new anchor.AnchorProvider(this.connection, this.anchorWallet, anchor.AnchorProvider.defaultOptions());
        this.programs = {
            world: new anchor.Program(world_json_1.default, world_json_1.default.metadata.address, this.provider),
            yggdrasil: new anchor.Program(yggdrasil_bolt_json_1.default, defs_2.PROGRAM_IDS[process.env.ENVIRONMENT].yggdrasil, this.provider),
            creature: new anchor.Program(creature_json_1.default, defs_2.PROGRAM_IDS[process.env.ENVIRONMENT].creature, this.provider),
            modifyCreature: new anchor.Program(modify_creature_json_1.default, defs_2.PROGRAM_IDS[process.env.ENVIRONMENT].modifyCreature, this.provider),
            sourcePerformActionOnTargetUsing: new anchor.Program(source_perform_action_on_target_using_json_1.default, defs_2.PROGRAM_IDS[process.env.ENVIRONMENT].sourcePerformActionOnTargetUsing, this.provider),
        };
    }
    /*
      Game Functions
    */
    initializeWorld() {
        return __awaiter(this, void 0, void 0, function* () {
            // Initialize world registry (Should already be there)
            const registryPda = (0, bolt_sdk_1.FindWorldRegistryPda)();
            const initializeRegistryIx = (0, bolt_sdk_1.createInitializeRegistryInstruction)({
                registry: registryPda,
                payer: this.anchorWallet.publicKey,
            });
            yield this.executeTransaction(new web3_js_1.Transaction().add(initializeRegistryIx));
            // Find the next available world
            const registry = yield this.programs.world.account.registry.fetch(registryPda);
            const worldId = registry.worlds;
            const worldPda = (0, bolt_sdk_1.FindWorldPda)(worldId);
            const initializeWorldIx = (0, bolt_sdk_1.createInitializeNewWorldInstruction)({
                world: worldPda,
                registry: registryPda,
                payer: this.anchorWallet.publicKey,
            });
            console.log(`
      Creating World: ${worldId}
      registryPda: ${registryPda}
      worldPda: ${worldPda}
    `);
            return yield this.executeTransaction(new web3_js_1.Transaction().add(initializeWorldIx));
        });
    }
    getPlayerPda(wallet) {
        return web3.PublicKey.findProgramAddressSync([
            anchor.utils.bytes.utf8.encode("player"),
            wallet !== undefined
                ? wallet.toBuffer()
                : this.anchorWallet.publicKey.toBuffer(),
        ], this.programs.yggdrasil.programId);
    }
    getPlayer() {
        return __awaiter(this, void 0, void 0, function* () {
            const [pda, _] = this.getPlayerPda();
            try {
                return yield this.programs.yggdrasil.account.player.fetch(pda);
            }
            catch (error) {
                return null;
            }
        });
    }
    getPlayerInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            // get player
            const player = yield this.getPlayer();
            if (player) {
                // get creature
                const [creaturePda, creature] = yield this.getCreature(player.entity);
                // get portrait
                const playerMetadata = yield (yield fetch((0, utils_2.nft_uri_to_url)(player.uri))).json();
                const portrait = (0, utils_2.nft_uri_to_url)(playerMetadata.image);
                return {
                    player,
                    portrait,
                    creature,
                    creaturePda,
                };
            }
            return null;
        });
    }
    attackCreature(sourceCreature, targetCreature) {
        return __awaiter(this, void 0, void 0, function* () {
            let ix = (0, bolt_sdk_1.createApply3Instruction)({
                componentProgram1: this.programs.creature.programId,
                componentProgram2: this.programs.creature.programId,
                componentProgram3: this.programs.creature.programId,
                boltComponent1: sourceCreature,
                boltComponent2: targetCreature,
                boltComponent3: sourceCreature,
                boltSystem: this.programs.sourcePerformActionOnTargetUsing.programId,
            }, {
                args: (0, utils_1.serializeArgs)({
                    action: Action.Damage,
                }),
            });
            const tx = new web3_js_1.Transaction();
            tx.add(ix);
            return yield this.executeTransaction(tx);
        });
    }
    getAllPlayerCreaturesLoggedIn() {
        return __awaiter(this, void 0, void 0, function* () {
            const creatures = yield this.programs.creature.account.creature.all([
                {
                    memcmp: {
                        offset: defs_1.DISCRIMINATOR_SIZE + defs_1.PUBKEY_SIZE,
                        bytes: (0, bs58_1.encode)(Buffer.from([1])),
                    },
                },
            ]);
            return creatures.map((x) => [x.publicKey, x.account]);
        });
    }
    getCreature(entity) {
        return __awaiter(this, void 0, void 0, function* () {
            const creature = (0, bolt_sdk_1.FindComponentPda)(this.programs.creature.programId, entity, "creature");
            let res = yield this.programs.creature.account.creature.fetch(creature);
            return [creature, res];
        });
    }
    createPlayer(name, uri) {
        return __awaiter(this, void 0, void 0, function* () {
            // create creature entity
            const [entity, creature] = yield this.createCreature(this.anchorWallet.publicKey, name);
            const [player, _] = this.getPlayerPda();
            const ix = yield this.programs.yggdrasil.methods
                .createPlayer(entity, name, uri)
                .accounts({
                player: player,
                signer: this.anchorWallet.publicKey,
                systemProgram: web3.SystemProgram.programId,
            })
                .instruction();
            const tx = new web3_js_1.Transaction();
            tx.add(ix);
            console.log(`
      wallet: ${this.anchorWallet.publicKey}
      player: ${player}
      entity: ${entity}
      creature: ${creature}
    `);
            return yield this.executeTransaction(tx);
        });
    }
    createCreature(authority, name) {
        return __awaiter(this, void 0, void 0, function* () {
            // create entity and creature for player
            const worldId = new bn_js_1.default(defs_2.WORLD_ID);
            const world = (0, bolt_sdk_1.FindWorldPda)(worldId);
            const entityId = (yield bolt_sdk_1.World.fromAccountAddress(this.connection, world))
                .entities;
            // get next entity id
            const entity = (0, bolt_sdk_1.FindEntityPda)(worldId, entityId);
            // create entity
            yield this.executeTransaction(new web3_js_1.Transaction().add((0, bolt_sdk_1.createAddEntityInstruction)({
                world: world,
                payer: authority,
                entity: entity,
            })));
            // create creature
            const creature = (0, bolt_sdk_1.FindComponentPda)(this.programs.creature.programId, entity, "creature");
            yield this.executeTransaction(new web3_js_1.Transaction().add((0, bolt_sdk_1.createInitializeComponentInstruction)({
                payer: authority,
                entity: entity,
                data: creature,
                componentProgram: this.programs.creature.programId,
            })));
            // initialize creature
            yield this.executeTransaction(new web3_js_1.Transaction().add((0, bolt_sdk_1.createApplyInstruction)({
                componentProgram: this.programs.creature.programId,
                boltComponent: creature,
                boltSystem: this.programs.modifyCreature.programId,
            }, {
                args: (0, utils_1.serializeArgs)({
                    modification: Modification.Initialize,
                    authority: authority.toString(),
                    name: name,
                }),
            })));
            return [entity, creature];
        });
    }
    /*
      Utils
    */
    confirmTransaction(signature, commitment) {
        return __awaiter(this, void 0, void 0, function* () {
            const bh = yield this.connection.getLatestBlockhash();
            const result = (yield this.connection.confirmTransaction({
                blockhash: bh.blockhash,
                lastValidBlockHeight: bh.lastValidBlockHeight,
                signature: signature,
            }, commitment)).value;
            console.log(`Transaction: ${signature} Result: ${result}`);
            return { result, signature };
        });
    }
    executeTransaction(tx, signers) {
        return __awaiter(this, void 0, void 0, function* () {
            // set latest blockhash
            tx.recentBlockhash = (yield this.connection.getLatestBlockhash("confirmed")).blockhash;
            // set payer
            tx.feePayer = this.anchorWallet.publicKey;
            // additional signers if required
            if (signers) {
                tx.partialSign(...signers);
            }
            // sign and send
            const signature = yield this.connection.sendRawTransaction((yield this.anchorWallet.signTransaction(tx)).serialize());
            // confirm transaction
            return yield this.confirmTransaction(signature);
        });
    }
    requestAirdrop(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            const signature = yield this.connection.requestAirdrop(this.anchorWallet.publicKey, amount);
            // confirm transaction
            return yield this.confirmTransaction(signature);
        });
    }
}
exports.AnchorClient = AnchorClient;
